import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/playbook'),
    name: 'playbook_view',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: () => import('./PlaybookView.vue'),
  },
];
